import React, { useEffect, useRef, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import useTranslation from "../../i18n/useTranslation";
import { getLocalizedGraphQLError } from "../../util/graphqlError";

const LINK_ORGANIZATION_INVITE = gql`
    mutation LinkOrganizationInvite ($organizationId: Int!, $seasonId: Int, $isManager: Boolean) {
        linkOrganizationInvite(organizationId: $organizationId, seasonId: $seasonId, isManager: $isManager) {
            inviteLink
        }
    }
`;

const InviteTeamLink = ({ organizationId, seasonId, isManager }) => {
    const { t } = useTranslation();
    const [getTeamInviteLink] = useMutation(LINK_ORGANIZATION_INVITE);
    const [inviteURL, setInviteURL] = useState("");

    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current && organizationId && seasonId) {
            hasFetched.current = true;
            getTeamInviteLink({
                variables: { organizationId, seasonId, isManager }
            }).then(({ data }) => {
                if (data?.linkOrganizationInvite?.inviteLink) {
                    setInviteURL(data.linkOrganizationInvite.inviteLink);
                }
            });
        }
    }, [organizationId, seasonId, getTeamInviteLink, isManager]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(inviteURL);
        } catch (err) {
            toast.error(getLocalizedGraphQLError(err, t), {
                autoClose: 3000,
                toastId: "link_error",
                position: "top-center",
                closeOnClick: true,
            });
        }
    };

    const handleEmail = () => {
        const subject = encodeURIComponent(t("inviteTeamLink.emailSubject"));
        const body = encodeURIComponent(
            t("inviteTeamLink.emailBody", { inviteURL })
        );
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
    };

    const handleWhatsApp = () => {
        const message = encodeURIComponent(
            t("inviteTeamLink.whatsAppMessage", { inviteURL })
        );
        window.open(`https://web.whatsapp.com/send?text=${message}`, "_blank");
    };

    return (
        <div className="alert alert-info alert-dismissible">
            <h5>
                <i className="icon fas fa-exclamation-triangle"></i>{" "}
                <b>{t("inviteTeamLink.title")}</b>
            </h5>

            <p style={{ fontSize: "1.0rem" }}>
                {t("inviteTeamLink.description")}
            </p>

            <div className="card-body">
                <button className="btn btn-kbola mr-2" onClick={handleCopy} type="button">
                    {t("inviteTeamLink.copyLink")}
                </button>

                <button className="btn btn-kbola mr-2" onClick={handleEmail} type="button">
                    {t("inviteTeamLink.sendEmail")}
                </button>

                <button className="btn btn-kbola mr-2" onClick={handleWhatsApp} type="button">
                    {t("inviteTeamLink.whatsApp")}
                </button>
            </div>
        </div>
    );
};

export default InviteTeamLink;
